import { createIcon } from '../createIcon';
import { ReactComponent as IconExclamationCircle } from '../svg/exclamation-circle.svg';

export default createIcon(IconExclamationCircle);
